import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from '../../services/GenesisApi';
import { GET_JOB_MESSAGE_TYPES, GET_JOB_PERIODS } from '../../constants/EUMarkets';

export type JobLookupRecord = Record<string, unknown>;

export type JobLookupsState = {
  jobPeriods: JobLookupRecord[];
  jobPeriodsLoaded: boolean;
  jobPeriodsLoading: boolean;
  jobMessageTypes: JobLookupRecord[];
  jobMessageTypesLoaded: boolean;
  jobMessageTypesLoading: boolean;
};

const initialState: JobLookupsState = {
  jobPeriods: [],
  jobPeriodsLoaded: false,
  jobPeriodsLoading: false,
  jobMessageTypes: [],
  jobMessageTypesLoaded: false,
  jobMessageTypesLoading: false,
};

// Shared across every screen that opens the jobs modal (Market Position, Contract View, ...) —
// fetched once the first time the modal is opened and cached here so re-opening it never re-requests.
export const fetchJobPeriods = createAsyncThunk('jobLookups/fetchJobPeriods', async () => {
  const response = await get(GET_JOB_PERIODS);
  return (response.data ?? []) as JobLookupRecord[];
});

export const fetchJobMessageTypes = createAsyncThunk(
  'jobLookups/fetchJobMessageTypes',
  async () => {
    const response = await get(GET_JOB_MESSAGE_TYPES);
    return (response.data ?? []) as JobLookupRecord[];
  },
);

const jobLookups = createSlice({
  name: 'JobLookups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobPeriods.pending, (state) => {
        state.jobPeriodsLoading = true;
      })
      .addCase(fetchJobPeriods.fulfilled, (state, action) => {
        state.jobPeriods = action.payload;
        state.jobPeriodsLoaded = true;
        state.jobPeriodsLoading = false;
      })
      .addCase(fetchJobPeriods.rejected, (state) => {
        state.jobPeriodsLoading = false;
      })
      .addCase(fetchJobMessageTypes.pending, (state) => {
        state.jobMessageTypesLoading = true;
      })
      .addCase(fetchJobMessageTypes.fulfilled, (state, action) => {
        state.jobMessageTypes = action.payload;
        state.jobMessageTypesLoaded = true;
        state.jobMessageTypesLoading = false;
      })
      .addCase(fetchJobMessageTypes.rejected, (state) => {
        state.jobMessageTypesLoading = false;
      });
  },
});

export default jobLookups.reducer;
